// eslint-disable-next-line
import { UserLayout, BasicLayout, RouteView, BlankLayout, PageView } from '@/layouts'

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/student/user/login',

    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: '泡芙教育' },
    redirect: '/dashboard',
    children: [
      // 首页
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/Index'),
        meta: { title: '首页', icon: 'desktop', hiddenPageTitle: true, keepAlive: true }
      },
      // 订单及学习进度
      {
        path: '/order',
        name: 'order',
        component: () => import('@/views/order/Index'),
        meta: { title: '订单及学习进度', icon: 'desktop', hiddenPageTitle: true, keepAlive: true }
      },
      // 约课管理
      {
        path: '/subscribe',
        name: 'subscribe',
        component: PageView,
        meta: { title: '网课预约', icon: 'solution', permission: ['form'] },
        redirect: '/subscribe/feijiaobooktime',
        hideChildrenInMenu: false,
        children: [
          {
            path: '/subscribe/feijiaobooktime',
            name: 'feijiaobooktime',
            component: () => import('@/views/subscribe/feijiaobooktime'),
            meta: { title: '菲教口语预约-按日期', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/subscribe/feijiaobookth',
            name: 'feijiaobookth',
            component: () => import('@/views/subscribe/feijiaobookth'),
            meta: { title: '菲教口语预约-按老师', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/subscribe/oumeibooktime',
            name: 'oumeibooktime',
            component: () => import('@/views/subscribe/oumeibooktime'),
            meta: { title: '欧美口语预约-按日期', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/subscribe/oumeibookth',
            name: 'oumeibookth',
            component: () => import('@/views/subscribe/oumeibookth'),
            meta: { title: '欧美口语预约-按老师', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/subscribe/zuowenbook',
            name: 'zuowenbook',
            component: () => import('@/views/subscribe/zuowenbook'),
            meta: { title: '作文批改预约', keepAlive: true, permission: ['user'] }
          }
        ]
      },
      // 默认计划及教程
      {
        path: '/plan',
        name: 'plan',
        component: PageView,
        meta: { title: '我的课表', icon: 'solution', permission: ['form'] },
        redirect: '/plan/feijiaokouyulist',
        hideChildrenInMenu: false,
        children: [
          // {
          //   path: '/plan/feijiaokouyulist',
          //   name: 'feijiaokouyulist',
          //   component: () => import('@/views/plan/feijiaokouyulist'),
          //   meta: { title: '菲教口语课表', keepAlive: true, permission: ['user'] }
          // },
          // {
          //   path: '/plan/oumeikouyulist',
          //   name: 'oumeikouyulist',
          //   component: () => import('@/views/plan/oumeikouyulist'),
          //   meta: { title: '欧美口语课表', keepAlive: true, permission: ['user'] }
          // },
          {
            path: '/plan/kouyulist',
            name: 'kouyulist',
            component: () => import('@/views/plan/kouyulist'),
            meta: { title: '口语课表', keepAlive: true, permission: ['user'] }
          },
          {
            path: '/plan/zuowenlist',
            name: 'zuowenlist',
            component: () => import('@/views/plan/zuowenlist'),
            meta: { title: '作文批改课表', keepAlive: true, permission: ['user'] }
          }
        ]
      },
      // 系统设置
      {
        path: '/system',
        name: 'system',
        // component: () => import('@/views/system/Index'),
        component: PageView,
        meta: { title: '系统管理', icon: 'setting', permission: ['form'] },
        redirect: '/system/base',
        hideChildrenInMenu: false,
        children: [
          // {
          //   path: '/system/my',
          //   name: 'my',
          //   component: () => import('@/views/account/center/Index'),
          //   meta: { title: '个人中心', keepAlive: true, permission: ['user'] }
          // },
          {
            path: '/system/base',
            name: 'base',
            component: () => import('@/views/system/base/Setting'),
            meta: { title: '个人中心', keepAlive: true, permission: ['user'] },
            redirect: '/system/base/system',
            hideChildrenInMenu: true,
            children: [
              {
                path: '/system/base/system',
                name: 'System',
                component: () => import('@/views/system/base/System'),
                meta: { title: '个人资料', keepAlive: true, permission: ['user'] }
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]
